export default "__VITE_ASSET__B$oXsmP7__"